import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import * as LucideIcons from 'lucide-react';

const Services = () => {
  const { t } = useLanguage();

  const getIcon = (iconName) => {
    const Icon = LucideIcons[iconName];
    return Icon ? <Icon className="w-8 h-8" /> : null;
  };

  return (
    <section id="services" className="relative py-20 lg:py-28 bg-[#F1F4F6]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0B2E4B] mb-4">
            {t.services.title}
          </h2>
          <p className="text-lg text-[#0B2E4B]/70 max-w-2xl mx-auto">
            {t.services.subtitle}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {t.services.items.map((service, index) => (
            <div
              key={service.id}
              className="group p-6 bg-white rounded-lg border border-gray-100 shadow-sm hover:shadow-xl hover:border-[#28BBC5]/30 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="w-14 h-14 flex items-center justify-center bg-[#BBEFF3]/50 rounded-lg text-[#28BBC5] group-hover:bg-[#28BBC5] group-hover:text-white transition-all duration-300">
                  {getIcon(service.icon)}
                </div>
              </div>
              <h3 className="text-lg font-semibold text-[#0B2E4B] mb-2 group-hover:text-[#28BBC5] transition-colors duration-300">
                {service.title}
              </h3>
              <p className="text-sm text-[#0B2E4B]/60 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
